import {
  Tooltip as MuiTooltip,
  styled,
  tooltipClasses,
  TooltipProps,
} from '@mui/material';

interface ITooltipProps extends TooltipProps {
  isDisabled?: boolean;
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.background.tertiary,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.background.tertiary,
    borderRadius: '6px',
    padding: theme.spacing(5, 4),
  },
  a: {
    color: theme.palette.primary.main,
  },
}));

const Tooltip = ({ isDisabled = false, ...props }: ITooltipProps) => {
  return (
    <StyledTooltip
      arrow
      enterDelay={300}
      enterNextDelay={0}
      disableFocusListener={isDisabled}
      disableHoverListener={isDisabled}
      disableTouchListener={isDisabled}
      {...props}
    />
  );
};

export default Tooltip;
